import * as m from "react";
import e from "./index180.mjs";
import { clsx as L } from "./clsx.mjs";
import { pickersLayoutClasses as n, getPickersLayoutUtilityClass as h } from "./pickersLayoutClasses.mjs";
import w from "./usePickerLayout.mjs";
import { jsxs as i, jsx as x } from "react/jsx-runtime";
import f from "./styled.mjs";
import O from "./useThemeProps.mjs";
import P from "./composeClasses.mjs";
const k = (s) => {
  const {
    isLandscape: o,
    classes: r
  } = s;
  return P({
    root: ["root", o && "landscape"],
    contentWrapper: ["contentWrapper"]
  }, h, r);
}, y = f("div", {
  name: "MuiPickersLayout",
  slot: "Root",
  overridesResolver: (s, o) => o.root
})(({
  theme: s,
  ownerState: o
}) => ({
  display: "grid",
  gridAutoColumns: "max-content auto max-content",
  gridAutoRows: "max-content auto max-content",
  [`& .${n.toolbar}`]: o.isLandscape ? {
    gridColumn: s.direction === "rtl" ? 3 : 1,
    gridRow: "2 / 3"
  } : {
    gridColumn: "2 / 4",
    gridRow: 1
  },
  [`.${n.shortcuts}`]: o.isLandscape ? {
    gridColumn: "2 / 4",
    gridRow: 1
  } : {
    gridColumn: s.direction === "rtl" ? 3 : 1,
    gridRow: "2 / 3"
  },
  [`& .${n.actionBar}`]: {
    gridColumn: "1 / 4",
    gridRow: 3
  }
}));
y.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  as: e.elementType,
  ownerState: e.shape({
    isLandscape: e.bool.isRequired
  }).isRequired,
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object])
};
const j = f("div", {
  name: "MuiPickersLayout",
  slot: "ContentWrapper",
  overridesResolver: (s, o) => o.contentWrapper
})({
  gridColumn: 2,
  gridRow: 2,
  display: "flex",
  flexDirection: "column"
}), v = function(o) {
  const r = O({
    props: o,
    name: "MuiPickersLayout"
  }), {
    toolbar: t,
    content: a,
    tabs: c,
    actionBar: R,
    shortcuts: p
  } = w(r), {
    sx: g,
    className: b,
    isLandscape: u,
    ref: C,
    wrapperVariant: q
  } = r, d = r, l = k(d);
  return /* @__PURE__ */ i(y, {
    ref: C,
    sx: g,
    className: L(b, l.root),
    ownerState: d,
    children: [u ? p : t, u ? t : p, /* @__PURE__ */ x(j, {
      className: l.contentWrapper,
      children: q === "desktop" ? /* @__PURE__ */ i(m.Fragment, {
        children: [a, c]
      }) : /* @__PURE__ */ i(m.Fragment, {
        children: [c, a]
      })
    }), R]
  });
};
process.env.NODE_ENV !== "production" && (v.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // | To update them edit the TypeScript types and run "yarn proptypes"  |
  // ----------------------------------------------------------------------
  children: e.node,
  classes: e.object,
  className: e.string,
  /**
   * Overridable components.
   * @default {}
   * @deprecated Please use `slots`.
   */
  components: e.object,
  /**
   * The props used for each component slot.
   * @default {}
   * @deprecated Please use `slotProps`.
   */
  componentsProps: e.object,
  disabled: e.bool,
  isLandscape: e.bool.isRequired,
  isValid: e.func.isRequired,
  onAccept: e.func.isRequired,
  onCancel: e.func.isRequired,
  onChange: e.func.isRequired,
  onClear: e.func.isRequired,
  onClose: e.func.isRequired,
  onDismiss: e.func.isRequired,
  onOpen: e.func.isRequired,
  onSelectShortcut: e.func.isRequired,
  onSetToday: e.func.isRequired,
  onViewChange: e.func.isRequired,
  /**
   * Force rendering in particular orientation.
   */
  orientation: e.oneOf(["landscape", "portrait"]),
  readOnly: e.bool,
  /**
   * The props used for each component slot.
   * @default {}
   */
  slotProps: e.object,
  /**
   * Overridable component slots.
   * @default {}
   */
  slots: e.object,
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  value: e.any,
  view: e.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]),
  views: e.arrayOf(e.oneOf(["day", "hours", "meridiem", "minutes", "month", "seconds", "year"]).isRequired).isRequired,
  wrapperVariant: e.oneOf(["desktop", "mobile"])
});
export {
  v as PickersLayout,
  j as PickersLayoutContentWrapper,
  y as PickersLayoutRoot
};
//# sourceMappingURL=PickersLayout.mjs.map
